import script from "./policyView.vue?vue&type=script&setup=true&lang=js"
export * from "./policyView.vue?vue&type=script&setup=true&lang=js"

import "./policyView.vue?vue&type=style&index=0&id=302c1076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302c1076"]])

export default __exports__